import { Button, reactive, Span, Div, not } from 'alkali'
import Icon from 'components/Icon'
import './FilterButton.scss'
import * as filterIcon from 'icons/filter-1.svg'
import { activeTab } from 'model/StudyCollection'

export const openFilterPane = reactive(window.innerWidth > 750)

setTimeout(() => {
    activeTab.subscribe(() => {
        if (activeTab == 'sources') {
            openFilterPane.put(window.innerWidth > 750)
        } else if (activeTab == 'extract' || activeTab == 'screening') {
            openFilterPane.put(false)
        }
    })
}, 20)

export const FilterButton = Button(
	'.filter-button',
	{
        onclick: () => {
            openFilterPane.put(!openFilterPane.valueOf())
        },
	},
    [
        Span('.filter-label', [
            Icon({ icon: filterIcon }),
            'Filters']),
        Span('.twisty', {
            classes: {
                'expander-icon-s': openFilterPane,
                'expander-icon-e': not(openFilterPane),
            },
            content: '➤'
        })
	]
)